import S10LogoPurple from "assets/s10logoPurple.svg"
import { FormattedMessage } from "react-intl"

import styles from "./brandWatermark.module.css"

export const BrandWatermark = () => {
  return (
    <p className={`${styles.brandWatermark} label-sm`}>
      <FormattedMessage
        id="general.brandWatermark"
        defaultMessage="Powered by"
      />
      <S10LogoPurple />
    </p>
  )
}
